import { notEmpty } from 'ha/utils/notEmpty';

export default params => {
  const query = Object.entries(params || {})
    .filter(pair => notEmpty(pair[1]))
    .map(pair => pair.map(encodeURIComponent).join('='))
    .join('&');

  return query ? `?${query}` : query;
};
